import { useHistory } from 'react-router-dom';

export const useCurrentMarket = () => {
  const history = useHistory();
  return {
    currentMarket: history.createHref({ pathname: '/' }).slice(1).replace(/\/$/, ''),
  };
};

export default useCurrentMarket;
